import React, { useState } from 'react';
import { auth, db } from '../firebase';
import { collection, addDoc, onSnapshot } from 'firebase/firestore';
import '../styles.css';

function PlanSelectionModal({ isOpen, onClose, subscriptionStatus }) {
  const [loading, setLoading] = useState(false);

  const selectPlan = async (priceId, planName) => {
    setLoading(true);

    try {
      // Create checkout session
      const checkoutRef = await addDoc(collection(db, 'customers', auth.currentUser.uid, 'checkout_sessions'), {
        price: priceId,
        success_url: window.location.origin + '/app',
        cancel_url: window.location.origin + '/app',
        mode: 'subscription',
      });

      onSnapshot(checkoutRef, (snap) => {
        const data = snap.data();
        if (data?.url) {
          window.location.assign(data.url);
        }
      });
    } catch (error) {
      alert('Error starting subscription: ' + error.message);
      setLoading(false);
    }
  };

  const selectLifetime = async () => {
    setLoading(true);

    try {
      // Create checkout session for one-time payment
      const checkoutRef = await addDoc(collection(db, 'customers', auth.currentUser.uid, 'checkout_sessions'), {
        price: 'price_1SxroDEziPoELaZZgceLkK5d',
        success_url: window.location.origin + '/app',
        cancel_url: window.location.origin + '/app',
        mode: 'payment',
      });

      onSnapshot(checkoutRef, (snap) => {
        const data = snap.data();
        if (data?.url) {
          window.location.assign(data.url);
        }
      });
    } catch (error) {
      alert('Error starting lifetime purchase: ' + error.message);
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000,
      padding: '20px'
    }}>
      <div style={{
        backgroundColor: 'white',
        borderRadius: '12px',
        padding: '30px',
        maxWidth: '900px',
        width: '100%',
        maxHeight: '90vh',
        overflow: 'auto',
        position: 'relative'
      }}>
        <button
          onClick={onClose}
          style={{
            position: 'absolute',
            top: '15px',
            right: '15px',
            background: 'none',
            border: 'none',
            fontSize: '24px',
            cursor: 'pointer',
            color: '#666'
          }}
        >
          ×
        </button>

        <h2 style={{ textAlign: 'center', marginBottom: '30px', color: '#333' }}>
          Choose Your Plan
        </h2>

        <div style={{
          display: 'flex',
          gap: '20px',
          flexDirection: window.innerWidth < 768 ? 'column' : 'row',
          flexWrap: 'wrap'
        }}>
          {/* Enthusiast Plan */}
          <div style={{
            flex: 1,
            border: '2px solid #e5e7eb',
            borderRadius: '8px',
            padding: '20px',
            textAlign: 'center',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            minHeight: '350px'
          }}>
            <div>
              <h3 style={{ color: '#333', marginBottom: '15px' }}>Enthusiast</h3>
              <div style={{ fontSize: '2rem', fontWeight: 'bold', color: '#2563eb', marginBottom: '15px' }}>
                $7<span style={{ fontSize: '1rem' }}>/month</span>
              </div>
              <ul style={{ textAlign: 'left', marginBottom: '20px', paddingLeft: '20px' }}>
                <li>Basic setup tracking</li>
                <li>Event management</li>
                <li>Standard tools</li>
                <li>Community support</li>
              </ul>
            </div>
            <button
              onClick={() => selectPlan('price_1SxrnoEziPoELaZZhEtGrG4k', 'Enthusiast')}
              disabled={loading}
              style={{
                width: '100%',
                padding: '12px',
                backgroundColor: '#2563eb',
                color: 'white',
                border: 'none',
                borderRadius: '6px',
                fontSize: '16px',
                cursor: 'pointer',
                opacity: loading ? 0.6 : 1
              }}
            >
              {loading ? 'Processing...' : 'Choose Enthusiast'}
            </button>
          </div>

          {/* Pro Plan */}
          <div style={{
            flex: 1,
            border: '2px solid #2563eb',
            borderRadius: '8px',
            padding: '20px',
            textAlign: 'center',
            backgroundColor: '#f8f9fa',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            minHeight: '350px',
            order: window.innerWidth < 768 ? -1 : 0
          }}>
            <div>
              <div style={{
                backgroundColor: '#2563eb',
                color: 'white',
                padding: '4px 12px',
                borderRadius: '12px',
                fontSize: '12px',
                display: 'inline-block',
                marginBottom: '10px'
              }}>
                Most Popular
              </div>
              <h3 style={{ color: '#333', marginBottom: '15px' }}>Pro</h3>
              <div style={{ fontSize: '2rem', fontWeight: 'bold', color: '#2563eb', marginBottom: '15px' }}>
                $21<span style={{ fontSize: '1rem' }}>/month</span>
              </div>
              <ul style={{ textAlign: 'left', marginBottom: '20px', paddingLeft: '20px' }}>
                <li>Advanced setup tracking</li>
                <li>Compensation recipes</li>
                <li>Track map notes</li>
                <li>Team collaboration</li>
                <li>Priority support</li>
              </ul>
            </div>
            <button
              onClick={() => selectPlan('price_1SxrnZEziPoELaZZPNBjkPXZ', 'Pro')}
              disabled={loading}
              style={{
                width: '100%',
                padding: '12px',
                backgroundColor: '#2563eb',
                color: 'white',
                border: 'none',
                borderRadius: '6px',
                fontSize: '16px',
                cursor: 'pointer',
                opacity: loading ? 0.6 : 1
              }}
            >
              {loading ? 'Processing...' : 'Choose Pro'}
            </button>
          </div>

          {/* Lifetime Pro Plan */}
          {(!subscriptionStatus || (subscriptionStatus.status !== 'active' && subscriptionStatus.status !== 'lifetime')) && (
            <div style={{
              flex: 1,
              border: '2px solid #10b981',
              borderRadius: '8px',
              padding: '20px',
              textAlign: 'center',
              backgroundColor: '#f0fdf4',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between',
              minHeight: '350px'
            }}>
              <div>
                <div style={{
                  backgroundColor: '#10b981',
                  color: 'white',
                  padding: '4px 12px',
                  borderRadius: '12px',
                  fontSize: '12px',
                  display: 'inline-block',
                  marginBottom: '10px'
                }}>
                  Best Value
                </div>
                <h3 style={{ color: '#333', marginBottom: '15px' }}>Lifetime Pro</h3>
                <div style={{ fontSize: '2rem', fontWeight: 'bold', color: '#10b981', marginBottom: '15px' }}>
                  $349<span style={{ fontSize: '1rem' }}> one-time</span>
                </div>
                <ul style={{ textAlign: 'left', marginBottom: '20px', paddingLeft: '20px' }}>
                  <li>All Pro features</li>
                  <li>No recurring payments</li>
                  <li>Lifetime access</li>
                  <li>Priority support</li>
                </ul>
              </div>
              <button
                onClick={() => selectLifetime()}
                disabled={loading}
                style={{
                  width: '100%',
                  padding: '12px',
                  backgroundColor: '#10b981',
                  color: 'white',
                  border: 'none',
                  borderRadius: '6px',
                  fontSize: '16px',
                  cursor: 'pointer',
                  opacity: loading ? 0.6 : 1
                }}
              >
                {loading ? 'Processing...' : 'Buy Lifetime'}
              </button>
            </div>
          )}
        </div>

        <div style={{ textAlign: 'center', marginTop: '20px' }}>
          <button
            onClick={() => { onClose(); window.open('/pricing', '_blank'); }}
            style={{
              background: 'none',
              border: 'none',
              color: '#2563eb',
              textDecoration: 'underline',
              cursor: 'pointer',
              fontSize: '14px'
            }}
          >
            See all differences
          </button>
        </div>
      </div>
    </div>
  );
}

export default PlanSelectionModal;